export const heroImage =
  'https://readdy.ai/api/search-image?query=warm%20coral%20orange%20and%20golden%20amber%20abstract%20stage%20light%20beams%20crossing%20a%20dark%20room%20with%20glowing%20bokeh%20particles%20and%20soft%20smoke%2C%20live%20streaming%20entertainment%20broadcast%20ambience%2C%20cinematic%20gradient%20backdrop%2C%20rich%20warm%20tones%20with%20gentle%20highlight%20glow%2C%20energetic%20and%20immersive%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=yy-hero-2026-x1&orientation=landscape';

export const features = [
  {
    icon: 'ri-live-line',
    title: '高清直播',
    desc: '流畅稳定的高清直播体验，热门才艺、游戏、户外等内容随时开播，边看边聊，弹幕互动零距离。',
  },
  {
    icon: 'ri-voiceprint-line',
    title: '语音连麦',
    desc: '多人语音频道实时畅聊，低延迟高保真音质，组队开黑、朋友闲聊、电台陪伴样样在行。',
  },
  {
    icon: 'ri-gamepad-line',
    title: '游戏开黑',
    desc: '海量游戏频道一键开黑，与主播和伙伴语音组队，实时协作配合，畅快竞技不卡顿。',
  },
  {
    icon: 'ri-mic-line',
    title: '线上K歌',
    desc: '点歌、合唱、抢麦一应俱全，虚拟舞台让你随时高歌，秀出好声音也能收获礼物与掌声。',
  },
  {
    icon: 'ri-heart-line',
    title: '交友互动',
    desc: '兴趣话题聚合真实用户，匿名聊天、同城圈子、互动小游戏，让每一次遇见都有温度。',
  },
  {
    icon: 'ri-gift-line',
    title: '礼物互动',
    desc: '丰富虚拟礼物与特效互动，为主播打call、参与活动，让每一次支持都更有趣味。',
  },
];

export const contentCards = [
  {
    tag: '才艺',
    title: '实力唱将直播间，每晚九点准时开唱',
    desc: '百万粉丝主播林小暖，翻唱热单、现场点歌，用歌声治愈你的每一个夜晚。',
    image:
      'https://readdy.ai/api/search-image?query=young%20female%20singer%20holding%20microphone%20performing%20on%20stage%20with%20warm%20coral%20spotlights%20and%20golden%20bokeh%20background%2C%20live%20talent%20show%20ambience%2C%20cinematic%20warm%20lighting%2C%20youthful%20and%20energetic%2C%20high%20detail&width=800&height=600&seq=yy-card-01&orientation=landscape',
  },
  {
    tag: '游戏',
    title: '电竞战队巅峰对决，超清赛事全程解说',
    desc: '王者荣耀、和平精英人气赛事轮番上演，职业解说带你读懂每一波精彩团战。',
    image:
      'https://readdy.ai/api/search-image?query=esports%20gamer%20wearing%20headset%20playing%20competitive%20game%20in%20front%20of%20glowing%20screens%2C%20warm%20amber%20and%20coral%20neon%20lighting%2C%20gaming%20arena%20ambience%2C%20cinematic%20depth%20of%20field%2C%20youthful%20energy%2C%20high%20detail&width=800&height=600&seq=yy-card-02&orientation=landscape',
  },
  {
    tag: '音乐',
    title: '线上K歌大赛火热开启，麦霸等你来战',
    desc: '每周主题歌会+合唱配对，素人也能登上虚拟舞台，人气TOP还有惊喜奖励。',
    image:
      'https://readdy.ai/api/search-image?query=person%20singing%20karaoke%20into%20microphone%20with%20warm%20golden%20stage%20lights%20and%20musical%20notes%20bokeh%20background%2C%20online%20k%20song%20competition%2C%20cinematic%20warm%20glow%2C%20festive%20and%20joyful%2C%20high%20detail&width=800&height=600&seq=yy-card-03&orientation=landscape',
  },
  {
    tag: '交友',
    title: '同城语音交友频道，遇见兴趣相投的你',
    desc: '按城市与兴趣精准匹配，轻松开麦畅聊，从第一句话开始认识新朋友。',
    image:
      'https://readdy.ai/api/search-image?query=two%20young%20friends%20chatting%20with%20headphones%20around%20warm%20amber%20and%20coral%20light%2C%20cozy%20voice%20social%20ambience%2C%20soft%20bokeh%20background%2C%20cinematic%20warm%20tone%2C%20friendly%20and%20welcoming%2C%20high%20detail&width=800&height=600&seq=yy-card-04&orientation=landscape',
  },
  {
    tag: '户外',
    title: '城市夜景直播，跟着镜头一起Citywalk',
    desc: '主播带你夜游城市地标，路边美食、街角故事，足不出户也能看遍人间烟火。',
    image:
      'https://readdy.ai/api/search-image?query=city%20street%20at%20night%20with%20warm%20neon%20and%20street%20lights%20glowing%2C%20vlogger%20live%20streaming%20outdoor%20citywalk%2C%20cinematic%20warm%20golden%20tones%2C%20atmospheric%20bokeh%2C%20high%20detail&width=800&height=600&seq=yy-card-05&orientation=landscape',
  },
  {
    tag: '电台',
    title: '深夜情感电台，陪你聊到天亮',
    desc: '主播用温柔声线讲述成长、爱与陪伴，戴上耳机，这里是属于你的深夜树洞。',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20bedroom%20night%20scene%20with%20warm%20lamp%20glow%20and%20headphones%20on%20desk%2C%20soft%20golden%20and%20coral%20lighting%2C%20calm%20midnight%20radio%20mood%2C%20cinematic%20warm%20tone%2C%20peaceful%20and%20intimate%2C%20high%20detail&width=800&height=600&seq=yy-card-06&orientation=landscape',
  },
];

export const guideSteps = [
  {
    step: '01',
    title: '访问官方网站',
    desc: '点击页面顶部"进入官方首页"按钮，或在浏览器地址栏输入歪歪官方网站地址，即可直达平台首页。',
  },
  {
    step: '02',
    title: '注册 / 登录账号',
    desc: '在官网首页右上角选择"登录"。已有账号可直接登录，新用户可一键注册，支持手机号或第三方快捷登录。',
  },
  {
    step: '03',
    title: '下载客户端',
    desc: '根据设备选择下载电脑版或手机版客户端，安装后使用同一账号登录，即可同步观看直播、加入语音频道。',
  },
  {
    step: '04',
    title: '开启娱乐之旅',
    desc: '进入频道广场挑选感兴趣的内容，关注喜欢的主播、加入话题圈子，享受完整的互动体验。',
  },
];

export const faqs = [
  {
    q: '歪歪官方网站入口地址是什么？',
    a: '歪歪官方网站入口可通过本页顶部"进入官方首页"按钮直达，也可在浏览器搜索栏输入"歪歪官方网站"并认准官网标识进入。建议将本导航页收藏，方便随时一键访问歪歪官方网站首页，快速进入登录流程。',
  },
  {
    q: '歪歪官方网站如何登录？',
    a: '进入歪歪官方网站首页后，点击页面右上角的"登录"按钮，输入已注册的手机号与密码即可登录。若忘记密码，可通过登录页的"忘记密码"入口，按提示通过手机验证码重置。',
  },
  {
    q: '歪歪官方网站支持哪些设备访问？',
    a: '歪歪官方网站适配电脑、平板与手机等多种设备。电脑用户可直接在官网首页下载客户端，手机用户可在应用商店搜索下载官方App，使用同一账号登录即可同步内容与好友关系。',
  },
  {
    q: '登录时提示账号不存在怎么办？',
    a: '请先确认注册时使用的手机号是否填写正确，或尝试使用验证码登录。若仍无法解决，可通过官网"意见反馈"入口提交问题，平台客服会协助核实账号信息。',
  },
  {
    q: '歪歪官方网站是免费使用的吗？',
    a: '歪歪官方网站与客户端的浏览、语音、直播等功能均可免费使用。平台内的部分虚拟礼物、会员权益等增值服务为付费项目，请根据个人需求理性选择，并通过官方正规渠道充值。',
  },
  {
    q: '本页与歪歪官方网站是什么关系？',
    a: '本页是歪歪官方网站的入口导航页，旨在为用户整理平台入口、地址、登录方式与使用指南，方便快速直达。平台内的具体内容与服务以歪歪官方网站实际展示为准。',
  },
];

export const testimonials = [
  {
    quote: '收藏了这个入口导航页之后，每天上歪歪看直播再也不用到处找地址了，一键直达特别省事。',
    name: '一位经常看直播的用户',
    role: '娱乐直播用户',
  },
  {
    quote: '登录步骤写得很清楚，手机号和验证码登录都试过，稳定顺畅，对新手特别友好。',
    name: '新注册用户',
    role: '语音社交用户',
  },
  {
    quote: '在电脑上看游戏直播画质很清晰，语音连麦也不卡，体验感一直很在线。',
    name: '游戏玩家',
    role: '游戏开黑用户',
  },
];